import hasBarShifts from "@/components/report/shared/hasBarShifts";
import hasPlural from "@/components/report/shared/hasPlural";
import { hasPeriodRefetch } from "./hasPeriodRefetch";

/**
 * "Naručeno" firme (telefon i računar): porudžbenice radnika razvrstane po smenama. Zahteva nasleđen stari tab
 * companyReportTabOrders (usersForShift, shiftDefinitions, selectedShifts, dates, fetchOrders). Smene iz
 * zaglavlja/trake dolaze preko hasBarShifts, a promena samo krajnjeg datuma osvežava podatke (hasPeriodRefetch).
 */
export default {
  mixins: [hasPlural, hasBarShifts, hasPeriodRefetch("fetchOrders")],
  computed: {
    isRange() {
      const { from, to } = this.dates;
      return Boolean(to && from !== to);
    },
    /** Smene sa narudžbama: porudžbenice radnika po imenu. */
    groups() {
      return this.shiftDefinitions
        .filter((shift) => this.selectedShifts.includes(shift.number))
        .map((shift) => {
          const slips = this.usersForShift(shift.name)
            .map((user) => this.toSlip(shift, user))
            .sort((a, b) => a.name.localeCompare(b.name));
          const mealCount = slips.reduce(
            (sum, slip) => sum + slip.meals.reduce((total, meal) => total + (Number(meal.total) || 0), 0),
            0
          );
          return { id: shift.number, slips, mealCount };
        })
        .filter((group) => group.slips.length);
    },
    workerTotal() {
      const ids = new Set();
      this.groups.forEach((group) => group.slips.forEach((slip) => ids.add(slip.id)));
      return ids.size;
    },
    mealTotal() {
      return this.groups.reduce((sum, group) => sum + group.mealCount, 0);
    },
  },
  methods: {
    toSlip(shift, user) {
      const meals = user[shift.name].meals;
      return {
        key: `${shift.number}-${user.id}`,
        id: user.id,
        name: [this.toLatin(user.name), this.toLatin(user.lastname)].filter(Boolean).join(" ").trim(),
        initials: [user.name, user.lastname]
          .filter(Boolean)
          .map((part) => String(part).charAt(0))
          .join(""),
        orderId: meals.length ? meals[0].order_id : "",
        meals: meals.map((meal) => ({ name: this.toLatin(meal.name), total: meal.quantity })),
      };
    },
    groupSummary(group) {
      return [
        this.pluralT("report_mobile.workers_n", group.slips.length),
        this.pluralT("report_mobile.meals_n", group.mealCount),
      ].join(" · ");
    },
  },
};
